import React from "react"
import { observer } from "mobx-react"
import styled from "styled-components"

import Spacer from "~/components/Spacer"
import LandingInput from "~/components/Form/LandingInput"
import FormError from "~/components/Form/ErrorText"
import InputTitle from "./InputTitle"
import useInject from "~/hooks/useInject"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;
`

const mapStore = store => ({
  divorceLookup: store.divorceLookup,
  validateDisplayMessage: store.divorceLookup.validateDisplayMessage,
  changeKey: store.divorceLookup.changeKey
})

const Text = ({ field, label, placeholder }) => {
  const { divorceLookup, changeKey, validateDisplayMessage } = useInject(mapStore)
  const errorHandler = validateDisplayMessage(field)

  const handleChange = ({ target: { name, value } }) => changeKey(name, value)

  return (
    <Wrapper>
      <InputTitle>{label}</InputTitle>

      <Spacer desktop={16} mobile={16} />

      <LandingInput
        name={field}
        placeholder={placeholder}
        value={divorceLookup[field]}
        onChange={handleChange}
        maxWidth="100%"
        error={errorHandler}
      />
      <FormError error={errorHandler} />
    </Wrapper>
  )
}

export default observer(Text)
